export function examConfig(selectPersonClick){
    return{
        
        // excelBtn: true, //
        menuType: "button",
        menuWidth: 260,
        menuAlign: "left",
        align: "center",
        card: true,
        refreshBtn: false,
        columnBtn: false,
        searchBtn: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        tip: false,
        lazy: true,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        tree: true,
        labelWidth: 150,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "客户名称/客户编号",
            prop: "search",
            hide: true,
            search: true,
            display: false,
            hideshow: true,
          },

          {
            sortable: "custom",
            label: "项目编号",
            prop: "number",
            width: "120",
            fixed: true,
            display: false,
          },
          {
            label: "项目名称",
            prop: "name",
            width: "200",
            fixed: true,
            display: false,
            rules: [
              {
                required: true,
                message: "请输入项目名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "项目类型",
            prop: "projectType",
            display: false,
            type: "select",
            search: true, 
            dataType: "string", 
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=zg_project_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            width: 300,
          },   
          {
            label: "经办人",
            prop: "managerUserName",
            searchClearable: false,
            search: false, 
            readonly: true, 
            
          },
          {
            label: "经办人",
            prop: "managerUserNames",
            span: 24,
            readonly: true,
            hideshow: true,
            click: () => { 
            selectPersonClick();
            },
            display: true,
            search: true,
            hide: true,
          },
           {
            label: "创建时间",
            prop: "createTime",
            searchClearable: false,
            readonly: true, 
            
          },
        ],
      
    } 
}